import PropType from "prop-types";
import AddonHeader from "./addonHeader";
import Footer from "./footer";
import AddonBody from "./addonBody";
import PropTypes from "prop-types";

/**
 * Component that provides the layout for the add-ons section,
 * including structure for displaying add-ons and managing layout elements.
 *
 * @param {Object} props - The component props.
 * @param {function} props.onClose - Function to handle closing the add-ons section.
 * @returns {JSX.Element} The rendered add-on layout component.
 */
const AddonLayout = ({ onClose, commonCleverTapData }) => {
  return (
    <div className="relative m-0 flex h-full flex-col overflow-hidden p-0  ">
      <div className="header h-[48px] border-b-0 border-lightGrey px-[16px] py-10 pt-[14px] md:border-b-1">
        <AddonHeader onClose={onClose} />
      </div>
      <div className={`content flex h-full flex-col justify-between overflow-hidden md:h-[72vh] md:justify-start`}>
        <AddonBody commonCleverTapData={commonCleverTapData} />
        <Footer commonCleverTapData={commonCleverTapData} />
      </div>
    </div>
  );
};

AddonLayout.propTypes = {
  onClose: PropType.func.isRequired,
  commonCleverTapData: PropTypes.object,
};

export default AddonLayout;
